<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Seguimiento
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Seguimiento
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-flex(xs12)
              v-layout(wrap)
                v-flex(xs6 sm3 style='margin-top:10px;margin-bottom:4px;')
                  v-select(outline
                    :items="clientes"
                    v-model="filtroCli"
                    style='padding-left: 15px;'
                    label="Cliente:")
                v-flex(xs6 sm3 style='display: flex;padding-left: 20px;align-items: center;')
                  v-btn(icon style="background:#4d9bd3;border-radius:10px;" @click='busqueda()').elevation-4
                    v-icon(color='white') search
        l-map(
          ref="map"
          :zoom="zooom"
          :center="centrarmapa"
          style="height: 500px; width: 100%"
        )
          l-tile-layer(:url="url")
          l-marker(
            v-for="(item, index) in marcadores"
            :key="index"
            :lat-lng="[item.coordenadas.lat, item.coordenadas.lng]"
            :icon="getIcon(item)"
            @click="openInfoWindowTemplate(item)"
          )
            l-popup
              div(style='display:flex;flex-direction:column;')
                span(v-if='item.cliente') 
                  b Cliente: 
                  | {{item.cliente}}
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";

// Solución para el problema de los iconos en producción usando CDN
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
export default {
  name: "mSeguimiento",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  data: vm => ({
    dialog4: false,
    ruta: serverImg,
    centrarmapa: [10.0738900, -69.3227800],
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    zooom: 12,
    filtroCli: "",
    info: {},
    marcadores: [],
    clientes: [],
  }),
  created() {
    this.initialize();
  },
  methods: {
    getIcon() {
      // Usar URLs CDN para los íconos de Leaflet
      return L.icon({
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
        iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
    },
    openInfoWindowTemplate(item) {
      this.info = item;
      if (this.$refs.map) {
        this.$refs.map.mapObject.setView([item.coordenadas.lat, item.coordenadas.lng], this.zooom);
      }
    },
    async busqueda() {
      this.infoWindow.open = false;
      this.marcadores = [];
      this.dialog4 = true;
      await Api.get("cliente/seguimiento?filtro=" + this.filtroCli).then(res => {
        res.data.forEach(el => {
          this.marcadores.push({
            icono: null,
            cliente: el.cli_des.trim(),
            coordenadas: {
              lat: parseFloat(el.campo7.trim()),
              lng: parseFloat(el.campo8.trim()),
            }
          })
        })
        this.dialog4 = false
      }).catch(err => {
        this.dialog4 = false
      })
    },
    async initialize() {
      this.dialog4 = true
      this.clientes = []
      this.marcadores = []
      this.clientes.push({
        text: "Todos",
        value: "1"
      })
      this.filtroCli = "1"
      await Api.get("cliente/seguimiento?filtro=" + this.filtroCli).then(res => {
        console.log(res.data)
        res.data.forEach(el => {
          this.clientes.push({
            text: el.cli_des.trim(),
            value: el.co_cli
          })
          this.marcadores.push({
            icono: null,
            cliente: el.cli_des.trim(),
            coordenadas: {
              lat: parseFloat(el.campo7.trim()),
              lng: parseFloat(el.campo8.trim()),
            }
          })
        })
        console.log(this.marcadores)
        this.dialog4 = false
      }).catch(err => {
        this.dialog4 = false
      })
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/seguimiento.scss";

.leaflet-container {
  font-family: 'Roboto', sans-serif;
  
  .leaflet-popup-content-wrapper {
    border-radius: 4px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    
    .leaflet-popup-content {
      margin: 10px;
      line-height: 1.4;
    }
  }
  
  .leaflet-popup-tip {
    box-shadow: none;
  }
}
</style>